module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAUBJREFUaEPtmGEOgyAMhdubbSfbdrJ5s25N1CgCRbAIWv64LAze19fSCULnAzvXDwZwtoPmgDlQGIHrpRARPQDgBQD8bGkMAPBBRH7OY+MAEX0bFD8JHhDxKQFQS2F3tSDiKug+B64F4BLXdoeIVgHd7YABFFpmDtwqhZwmyE3nXZhBUC2F/ocFi+UOvhxBiHE+SJBVAALiJ5ANhDM/6pQ6gCB+A5HhlF4fSBQ/Q4wf3DTjr2OppgMQEf+JCPXV9DkpJKVCojviSaVaA1Ix7i1unz2qALyhdBxKTkl9Qh1AErCA5OL1vlXF1mgCIAUyNMcAbvVnriRVLIWmCLhFoxHVkjV3vxOXbKbx2xSA7i+2+r5a1LBdc83r3U5rRktj7WwHjj5uczu+ARyVFubAUZGsvU52DdQWGtrPAM52onsHfohmJ0D/3p7MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/screen.png
// module id = 0dlO
// module chunks = 2